import axios from 'axios';

const $axios = axios.create({
  baseURL: 'https://ziswaf.masjed.id/apis/front',
});

export default $axios;
